import FormController from 'controllers/form-controller';
import Rails from 'rails-ujs';
import events from 'lib/events';
import { trim, triggerCustomEvent, featureEnabled } from 'lib/helpers';
import { sendTrackingEvent, NEW_ANALYTICS_FEATURE } from 'components/analytics/conversions/tracking';
import { COLLECTION_SAVE_COMPLETE, COLLECTION_REMOVE_COMPLETE, COLLECTION_CREATED_COMPLETE } from 'components/analytics/conversions/constants/actions';
import { sanitizeTerm } from 'lib/search-helpers';

export default class CollectionsModalFormController extends FormController {
  static targets = [
    'collectionsList',
  ];

  static values = {
    contentType: String,
    isPro: Boolean,
  }

  completeEventsToProcess = [];

  connect() {
    this.searchForm = document.querySelector('[data-controller="collections-search-form"]');

    this.collectionPrivacyField = this.element.querySelector('#collection_private');
    this.collectionSaveAction = this.element.getAttribute('action');

    triggerCustomEvent('hidePromoPopup');
    triggerCustomEvent('hideCollectionAlert');
  }

  saveNewCollection = (event) => {
    event.preventDefault();
    triggerCustomEvent(events.collections.created, {});

    this.validateFields(() => {
      if (this.collectionWithName()) {
        this.saveToCollection(event);
      } else {
        this.element.setAttribute('action', this.collectionSaveAction);

        this.addCompleteEvent(COLLECTION_CREATED_COMPLETE);
        this.addCompleteEvent(COLLECTION_SAVE_COMPLETE);
        this.saveCollection();
      }
    });
  }

  saveToCollection = (event) => {
    event.preventDefault();
    triggerCustomEvent(events.collections.resource_added, {});

    const targetCollection = this.targetIsCollectionListItem(event.currentTarget)
      ? event.currentTarget : this.collectionWithName();

    const collectionId = targetCollection.getAttribute('data-collection-id');
    const collectionPrivacy = targetCollection.getAttribute('data-privacy');

    this.searchForm.value = trim(targetCollection.querySelector('.collections-list__item__name').innerHTML);

    this.collectionPrivacyField.value = collectionPrivacy;

    this.element.setAttribute('action', `${this.collectionSaveAction}/${collectionId}/items`);

    this.addCompleteEvent(COLLECTION_SAVE_COMPLETE);
    this.saveCollection();
  }

  removeFromCollection = (event) => {
    event.preventDefault();
    triggerCustomEvent(events.collections.resource_removed, {});

    const targetCollection = this.targetIsCollectionListItem(event.currentTarget)
      ? event.currentTarget : this.collectionWithName();

    const collectionId = targetCollection.getAttribute('data-collection-id');
    const collectionItem = targetCollection.getAttribute('data-collection-item-id');
    const resource = this.element.querySelector('#collection-item-id');

    resource.insertAdjacentHTML('beforebegin', '<input type="hidden" name="_method" value="delete">');

    this.element.setAttribute('action', `${this.collectionSaveAction}/${collectionId}/items/${collectionItem}`);

    this.addCompleteEvent(COLLECTION_REMOVE_COMPLETE);

    this.saveCollection();
  }

  saveCollection = () => {
    this.element.addEventListener('ajax:success', this.ajaxSuccess.bind(this));

    Rails.fire(this.element, 'submit');

    triggerCustomEvent(events.modal.close_modal);

    return true;
  }

  ajaxSuccess(event) {
    // insert success message
    const collectionAlertHTML = event.detail[0].body.innerHTML;
    document.body.insertAdjacentHTML('beforeend', collectionAlertHTML);

    // process complete events
    this.completeEventsToProcess.forEach((completeEvent) => this.trackEvent(completeEvent));
    this.completeEventsToProcess = [];
  }

  addCompleteEvent(eventName) {
    this.completeEventsToProcess.push(eventName);
  }

  trackEvent(action) {
    if (featureEnabled(NEW_ANALYTICS_FEATURE)) {
      sendTrackingEvent({
        data: {
          action,
          label: this.isProValue ? 'Pro' : 'Free',
          content_type: `Content-${this.contentTypeValue}`,
        },
      });
    }
  }

  validateFields(callback) {
    super.validateFields();

    if (this.formValid) {
      callback();
    }
  }

  collectionWithName() {
    const collectionName = sanitizeTerm(this.searchForm.value);
    if (trim(collectionName).length <= 0) return false;
    return this.collectionsListTarget.querySelector(`[data-collection-name="${collectionName}"]`);
  }

  targetIsCollectionListItem(target) {
    return target.getAttribute('data-target').indexOf('collections-modal.collectionsListItem') > -1;
  }
}
